import { Title } from '@mantine/core';

export default function ImportPayslipsTitle({ title }: { title: string }) {
  return (
    <Title size={'h5'} c={'hifivework.5'}>
      {title}
    </Title>
  );
}
